import React from 'react'
import { Row, Col, Container } from 'reactstrap';
import styles from './RightsReserved.module.css';
import { MdCopyright } from 'react-icons/md';

const RightsReserved = () => {
    return (
        <Container fluid>
            <Row>
                <Col xs='12' sm='12' md='12' lg='12' className={styles.rights}>
                    <p className="fade-in"><MdCopyright /> All Rights Reserved {(new Date().getFullYear())} Yogsadhna Varga.</p>
                </Col>
            </Row>
        </Container>
    );
}
export default RightsReserved;